/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Load_Failed1Inputs */

const vi_sitesettings_load_failed1 = /** @type {(inputs: Sitesettings_Load_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được cài đặt website. Tải lại trang để thử lại.`)
};

/**

* @param {Sitesettings_Load_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_load_failed1 = /** @type {((inputs?: Sitesettings_Load_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Load_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_load_failed1(inputs)
});
export { sitesettings_load_failed1 as "siteSettings_load_failed" }